import AccountBalanceWalletRounded from '@mui/icons-material/AccountBalanceWalletRounded';
import type { ModuleDefinition } from '../types';

export const financeModule: ModuleDefinition = {
  key: 'finance',
  label: 'Finanças',
  description: 'Contas, transações, documentos e investimentos.',
  icon: AccountBalanceWalletRounded,
  nav: [
    {
      to: '/financas',
      label: 'Finanças',
      icon: AccountBalanceWalletRounded,
      rule: { module: 'finance', anyPermission: ['finance.self', 'finance.clients.read'] },
    },
  ],
  routes: [
    {
      path: '/financas/*',
      lazy: async () => ({ Component: (await import('./pages/FinancePage')).FinancePage }),
    },
  ],
};
